module.exports = __webpack_public_path__ + "img/edit.8182d867.svg";